import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of, Subscription } from 'rxjs';
import { selectSelectedTenant } from 'src/app/auth/state/selectors/user-tenant.selector';
import { Tenant } from 'src/app/core/models/tenant';
import { SingleTenantStatsComponent } from '../single-tenant-stats/single-tenant-stats.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-user-dashboard',
    template: `
    <section class="row mt-3">
      @if (resolvedTenant$ | async; as resolvedTenant) {
        <app-single-tenant-stats [tenant]="resolvedTenant"></app-single-tenant-stats>
      }
    </section>
  `,
    styleUrls: ['./user-dashboard.component.scss'],
    imports: [SingleTenantStatsComponent, AsyncPipe]
})
export class UserDashboardComponent implements OnInit, OnDestroy {
  private store = inject(Store);

  readonly tenant = input<Observable<Tenant.Tenant> | null>(null);
  resolvedTenant$!: Observable<Tenant.Tenant>;
  sub = new Subscription();

  ngOnInit(): void {
    const tenantValue = this.tenant();
    if (!tenantValue) {
      this.resolvedTenant$ = this.store.select(selectSelectedTenant);
    } else {
      const sub = tenantValue.subscribe(tenant => this.resolvedTenant$ = of(tenant));
      this.sub.add(sub);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}